export default {"src":"/_next/static/media/mt5-windows.4e352c43.svg","height":394,"width":555,"blurWidth":0,"blurHeight":0};